import { render, staticRenderFns } from "./DataRelationList.vue?vue&type=template&id=02c2b1e6&scoped=true&"
import script from "./DataRelationList.vue?vue&type=script&lang=js&"
export * from "./DataRelationList.vue?vue&type=script&lang=js&"
import style0 from "./DataRelationList.vue?vue&type=style&index=0&id=02c2b1e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2b1e6",
  null
  
)

export default component.exports